/**
 * API service for video generation
 */

import { apiPost } from "./apiClient";
import type {
  GenerateVideoRequest,
  GenerateVideoResponse,
  CheckGenerationStatusResponse,
} from "@shared/schemas/api";

export type { GenerateVideoRequest, GenerateVideoResponse, CheckGenerationStatusResponse } from "@shared/schemas/api";

/**
 * Call the generate-video API to create a video generation task
 */
export async function generateVideo(
  params: GenerateVideoRequest
): Promise<GenerateVideoResponse> {
  try {
    return await apiPost<GenerateVideoResponse>(
      "/api/generate-video",
      params as unknown as Record<string, unknown>
    );
  } catch (error) {
    console.error("Error calling generate-video:", error);
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : "Failed to start video generation",
      code: (error as Error & { code?: string })?.code,
    };
  }
}

/**
 * Call the unified check-generation-status API to check task status
 */
export async function checkGenerationStatus(
  id: string,
  type: "image" | "video"
): Promise<CheckGenerationStatusResponse> {
  try {
    return await apiPost<CheckGenerationStatusResponse>(
      "/api/check-generation-status",
      { id, type }
    );
  } catch (error) {
    console.error("Error calling check-generation-status:", error);
    return {
      success: false,
      status: "failed",
      error:
        error instanceof Error
          ? error.message
          : "Failed to check generation status",
    };
  }
}
